import { useSelector } from 'react-redux';
import { Image } from '@vinted/web-ui';
import classNames from 'classnames';
import { noop } from 'lodash';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { STATIC_ASSETS_URL } from 'constants/index';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { ROOT_URL } from 'constants/routes';
import { clickEvent } from 'libs/common/event-tracker/events';
import { portalLogoBrand } from 'libs/utils/portal';
import { getUser } from 'state/session/selectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LOGO_ASSET_URL = "".concat(STATIC_ASSETS_URL, "/assets/web-logo");

const HeaderLogo = _ref => {
  let {
    portal,
    onClick = noop
  } = _ref;
  const translate = useTranslate('header.a11y');
  const {
    track
  } = useTracking();
  const user = useSelector(getUser);
  const isDe = ['de', 'de_babies'].includes(portal);
  const brand = portalLogoBrand(portal);

  const handleLogoClick = event => {
    const trakingEvent = clickEvent({
      target: ClickableElement.Logo
    });
    track(trakingEvent);
    return onClick(event);
  };

  const renderDesktopLogo = () => /*#__PURE__*/_jsx("div", {
    className: classNames('l-header__logo-container', {
      'l-header__logo-container--wide': isDe
    }),
    children: /*#__PURE__*/_jsx(Image, {
      src: "".concat(LOGO_ASSET_URL, "/").concat(brand, "/logo.svg"),
      alt: translate('logo')
    })
  });

  const renderLogo = () => /*#__PURE__*/_jsx("div", {
    className: "u-ui-padding-left-small",
    children: renderDesktopLogo()
  });

  const renderAuthenticatedLogo = () => /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "u-phones-only",
      children: /*#__PURE__*/_jsx(Image, {
        src: "".concat(LOGO_ASSET_URL, "/").concat(brand, "/symbol.svg"),
        alt: translate('logo')
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classNames('u-tablets-up-only', 'u-ui-padding-left-small'),
      children: renderDesktopLogo()
    })]
  });

  return /*#__PURE__*/_jsx("div", {
    className: "l-header__logo",
    children: /*#__PURE__*/_jsx("a", {
      className: "u-block",
      href: ROOT_URL,
      title: translate('logo'),
      "aria-label": translate('logo'),
      onClick: handleLogoClick,
      "data-testid": "header-logo-id",
      children: user ? renderAuthenticatedLogo() : renderLogo()
    })
  });
};

export default HeaderLogo;